// extracted by mini-css-extract-plugin
export default {"headerContainer":"GadgetInfoTopic_headerContainer__ls8Lr","headerText":"GadgetInfoTopic_headerText__xxkcy","descriptionText":"GadgetInfoTopic_descriptionText__R3cLA"};